import React from 'react';
import { useNotification } from '../../context/NotificationContext';
const iconMap = {
    success: 'check-circle',
    danger: 'times-circle',
    warning: 'exclamation-triangle',
    info: 'info-circle',
};
const ToastContainer = () => {
    const { toasts, removeToast } = useNotification();
    if (toasts.length === 0)
        return null;
    return (React.createElement("div", { "aria-live": "polite", style: {
            position: 'fixed',
            top: '70px',
            right: '20px',
            zIndex: 9999,
            maxWidth: '380px',
            width: '100%',
        } }, toasts.map((toast) => (React.createElement("div", { key: toast.id, className: `alert alert-${toast.type} alert-dismissible`, role: "alert", style: {
            marginBottom: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,.15)',
            animation: 'fadeIn 0.3s ease-in',
        } },
        React.createElement("button", { type: "button", className: "close", onClick: () => removeToast(toast.id), "aria-label": "Close" },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7")),
        React.createElement("i", { className: `fa fa-${iconMap[toast.type]}` }),
        " ",
        toast.message)))));
};
export default ToastContainer;
